import React, { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = (props) => {
    const [token, setToken] = useState(localStorage.getItem("someUserToken"));

    useEffect(() => {
        const fetchUser = async () => {
            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            };

            const response = await fetch("/storage/api/users/me", requestOptions);

            if (!response.ok) {
                setToken(null);
            }
            localStorage.setItem("someUserToken", token);
        };
        fetchUser();
    }, [token]);

    return <UserContext.Provider value={[token, setToken]}>{props.children}</UserContext.Provider>;
};
